/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSession } from './oralExamSession';

export type SubmissionOralExamSession = OralExamSession | null;
